import allForms from "@/pages/Organization/Forms5/allForms";

export const OKCPList = [
  {
    path: '/admin',
    name: 'admin',
    text: 'Админка',
    roles: ['ADMIN_ROLE']
  },
  {
    path: '/co',
    name: 'co',
    text: 'Центры ответственности',
    roles: ['ADMIN_ROLE']
  },
  {
    path: '/regions',
    name: 'regions',
    text: 'Субъекты РФ',
    roles: ['ADMIN_ROLE']
  },
  {
    path: '/envelopes',
    name: 'envelopes',
    text: 'Получение конвертов',
    roles: ['ADMIN_ROLE']
  },
  {
    name: 'appeals-org',
    text: 'Апелляции по организациям',
    roles: ['ADMIN_ROLE']
  },
  {
    name: 'appeals-fives',
    text: 'Апелляции по 5м формам',
    roles: ['ADMIN_ROLE']
  },
  {
    name: 'appeals-indicators',
    text: 'Апелляции по сводной оценке',
    roles: ['ADMIN_ROLE']
  },
  {
    name: 'organizations',
    text: 'Список организаций',
    roles: ['ADMIN_ROLE']
  },
  {
    name: 'founders',
    text: 'Список министерств',
    roles: ['ADMIN_ROLE']
  },
]

export const OrganizationList = [
  {
    additionalHeader: 'Показатели деятельности',
    name: 'FormList',
    text: 'Общий список',
    roles: ['ORGANIZATION_ROLE']
  },
  ...allForms.map(el => ({
    path: '/forms/' + el.formId,
    text: el.text,
    roles: ['ORGANIZATION_ROLE']
  })),
  {
    additionalHeader: 'Дополнительные данные',
    name: 'FormA',
    text: 'Таблица А.',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'FormB',
    text: 'Таблица Б.',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'FormV',
    text: 'Таблица В.',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'FormG',
    text: 'Таблица Г.',
    roles: ['ORGANIZATION_ROLE']
  },
]